import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { IprAnswerRecord, OrcadentQuestionnaireDataRecord, OrcadentQuestionnaireSection, Quadrant, OrcadentQuestionnaireModel, RemoveAttachmentsForMovementAnswerRecord, ThreeOptionsAnswer } from "../models/questionnaire-orcadent.model";
import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";


@Component({
	selector: "suite-questionnaire-orcadent-dialog",
	standalone: true,
	imports: [
		CommonModule,
		TranslateModule,
		MatDialogModule,
		MatButtonModule
	],
	templateUrl: "./questionnaire-orcadent-dialog.component.html",
	styleUrl: "./questionnaire-orcadent-dialog.component.scss"
})


export class QuestionnaireOrcadentDialogComponent {

	Quadrant = Quadrant;

	OrcadentQuestionnaireSection = OrcadentQuestionnaireSection;
	questionnaireData: OrcadentQuestionnaireModel;
	initialWidth: string;
	initialHeight: string;

	constructor(private translateService: TranslateService,
				@Inject(MAT_DIALOG_DATA) protected data: {
					patientName?: string,
					questionnaireData: OrcadentQuestionnaireModel,
					width: string,
					height: string,
				}
	){
		this.questionnaireData = data.questionnaireData;
		this.initialWidth = data.width;
		this.initialHeight = data.height;
	}

	getRemoveAttachmentsForMovementAnswer(isUpperJaw: boolean): string{
		let modelData = isUpperJaw
			? this.questionnaireData.removeAttachmentsForMovement.uj
			: this.questionnaireData.removeAttachmentsForMovement.lj;
		return this.getAnswerFromRecord(modelData, RemoveAttachmentsForMovementAnswerRecord);
	}

	getIprAnswer(isUpperJaw: boolean): string{
		let modelData = isUpperJaw
			? this.questionnaireData.ipr.uj
			: this.questionnaireData.ipr.lj;
		return this.getAnswerFromRecord(modelData, IprAnswerRecord);
	}

	private getAnswerFromRecord(modelData: any, record: Record<ThreeOptionsAnswer, String>): string{
		if (modelData.option === ThreeOptionsAnswer.OTHER) {
			return `${this.translateService.instant(
				record[modelData.option as ThreeOptionsAnswer].toString()
			)}: ${modelData.text}`;
		} else {
			return this.translateService.instant(
				record[modelData.option as ThreeOptionsAnswer].toString()
			);
		}
	}

	getAnteriorTeethAnswer(isUpperJaw: boolean): string{
		let result = '';
		let modelData = isUpperJaw ? this.questionnaireData.anteriorTeeth.uj : this.questionnaireData.anteriorTeeth.lj;
		if(modelData.protrude_retrude.option){
			result = result.concat(`${this.translateService.instant(modelData.protrude_retrude.option)}${modelData.protrude_retrude.text ? ": " + modelData.protrude_retrude.text : ""}`, '<br>');
		}
		if(modelData.procline_recline.option){
			result = result.concat(`${this.translateService.instant(modelData.procline_recline.option)}${modelData.procline_recline.text ? ': ' + modelData.procline_recline.text : ""}`, '<br>');
		}
		if(modelData.compress_expand.option){
			result = result.concat(`${this.translateService.instant(modelData.compress_expand.option)}${modelData.compress_expand.text ? ': ' + modelData.compress_expand.text : ""}`, '<br>');
		}
		if(modelData.torque.option){
			result = result.concat(`${this.translateService.instant(modelData.torque.option)}${modelData.torque.text ? ": " + modelData.torque.text : ""}`);
		}
		return result === '' ? '-' : result;
	}

	getPosteriorTeethAnswer(quadrant: Quadrant): string{
		let result = '';
		let modelData;
		if(quadrant === Quadrant.Q1){
			modelData = this.questionnaireData.posteriorTeeth.q1;
		}else if (quadrant === Quadrant.Q2){
			modelData = this.questionnaireData.posteriorTeeth.q2;
		}else if (quadrant === Quadrant.Q3){
			modelData = this.questionnaireData.posteriorTeeth.q3;
		}else if (quadrant === Quadrant.Q4){
			modelData = this.questionnaireData.posteriorTeeth.q4;
		}
		if(modelData.compress_expand.option){
			result = result.concat(`${this.translateService.instant(modelData.compress_expand.option)}${modelData.compress_expand.text ? ": " + modelData.compress_expand.text : ""}`, '<br>');
		}
		if(modelData.distalize_mesialize.option){
			result = result.concat(`${this.translateService.instant(modelData.distalize_mesialize.option)}${modelData.distalize_mesialize.text ? ": " + modelData.distalize_mesialize.text : ""}`, '<br>');
		}
		return result === '' ? '-' : result;
	}

	protected printDialog() {
		const dialogElement = document.querySelector("mat-dialog-container") as HTMLElement;
		if (dialogElement) {
			//display dialog in fullscreen
			dialogElement.style.position = "absolute";
			dialogElement.style.top = "0";
			dialogElement.style.left = "0";
			dialogElement.style.width = "100vw";
			dialogElement.style.maxWidth = "100vw";
			dialogElement.style.height = "100vh";
			window.print();

			//reset size and position of dialog
			dialogElement.style.position = "static";
			dialogElement.style.width = this.initialWidth;
			dialogElement.style.height = this.initialHeight;
		}
	}

	protected getHeadline(section: OrcadentQuestionnaireSection): string{
		return OrcadentQuestionnaireDataRecord[section].headline;
	}
}


